export const RENTALS_CODE = {
  OPAQUE: 1044,
  MOVIDA: 3,
  FOCO: 185,
  BILLIONAIRES: 11278
}

export const RENTALS = {
  'companies': [
    {
      'code': 61,
      'name': 'AVIS',
      'background_color': '#D40029',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 797,
      'name': 'ALTERNATIVACAR',
      'background_color': '#BD0800',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 779,
      'name': 'ACE',
      'background_color': '#16437F',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 686,
      'name': 'ALAMO',
      'background_color': '#0059A2',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 804,
      'name': 'AMERICACARRENTAL',
      'background_color': '#1F5EAD',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 869,
      'name': 'CENTAURO',
      'background_color': '#16437F',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 714,
      'name': 'DOLLAR',
      'background_color': '#C8202F',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 834,
      'name': 'ENTERPRISE',
      'background_color': '#169A5A',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 732,
      'name': 'EUROPCAR',
      'background_color': '#666666',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 185,
      'name': 'FOCO',
      'background_color': '#F20000',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 778,
      'name': 'GOLDCAR',
      'background_color': '#16437F',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 787,
      'name': 'GUERIN',
      'background_color': '#3FAE12',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 1,
      'name': 'HERTZ',
      'background_color': '#666666',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 777,
      'name': 'INTERRENT',
      'background_color': '#16437F',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 783,
      'name': 'KEDDY',
      'background_color': '#45008E',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 173,
      'name': 'LOCALIZA',
      'background_color': '#00984A',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 833,
      'name': 'MAS',
      'background_color': '#16437F',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 798,
      'name': 'MEX_RENT_A_CAR',
      'background_color': '#1B4591',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 830,
      'name': 'MIDWAY',
      'background_color': '#16437F',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 3,
      'name': 'MOVIDA',
      'background_color': '#EF6B01',
      'buttons_color': 'green' // 'orange' or 'green'
    },
    {
      'code': 737,
      'name': 'NATIONAL',
      'background_color': '#016527',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 751,
      'name': 'FOX',
      'background_color': '#16437F',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 823,
      'name': 'ROUTES',
      'background_color': '#16437F',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 135,
      'name': 'SIXT',
      'background_color': '#FF6801',
      'buttons_color': 'green' // 'orange' or 'green'
    },
    {
      'code': 6,
      'name': 'THRIFTY',
      'background_color': '#0072B8',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 47,
      'name': 'UNIDAS',
      'background_color': '#025095',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 824,
      'name': 'ECONORENT',
      'background_color': '#008536',
      'buttons_color': 'orange' // 'orange' or 'green'
    },
    {
      'code': 807,
      'name': 'DRIVEONHOLIDAYS',
      'background_color': '#FC9300',
      'buttons_color': 'green' // 'orange' or 'green'
    },
    {
      'code': 844,
      'name': 'FIREFLY',
      'background_color': '#834590',
      'buttons_color': 'orange' // 'orange' or 'green'
    }
  ]
}
